import dealCounts from '../DealCounts/DealCounts.vue';
import global from '__jsVueMixin/global';
import cImg from '__jsVueUI/c-img/c-img.vue';
export default {
	mixins:     [global],
	components: {
		dealCounts,
		'c-img':     cImg,
	},
	props: {
		deal: {
			type: Object
		},
		page: {
			type:    String,
			default: ''
		},
		showDealValues: {
			type:    Boolean,
			default: false
		},
		showCreator: {
			type:    Boolean,
			default: false
		},
		showCloneBtn:       {},
		showDeleteBtn:      {},
		showEditBtn:        {},
		showMakePrivateBtn: {
			type:    Boolean,
			default: false
		},
	},
	computed: {
		canEditBtn() {
			if (this.showEditBtn === undefined) {
				return this.deal.can_edit;
			}
			return this.showEditBtn;
		},
		canDeleteBtn() {
			if (this.showDeleteBtn === undefined) {
				return this.deal.can_edit;
			}
			return this.showDeleteBtn;
		}
	},
	filters: {
		coc: function(value) {
			let coc = Number(value);
			return Math.ceil(coc * 100) / 100;
		}
	}
};
